import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/authContext";
import AppContent from "../templates/wrapper/AppContent";
import ChangePasswordForm from "../organisms/forms/changePassword/ChangePasswordForm";
import { useToast } from "../../hooks/useToast";

const ChangePassword = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { t } = useTranslation();
  const { showToast } = useToast();

  const onSubmit = async (values) => {
    try {
      if (values.newPassword !== values.newPasswordConfirm) {
        showToast("error", t("forgotPassword.passwordError"));
        return;
      }
      await authContext.changePassword(values.oldPassword, values.newPassword);
      await authContext.signOut(false);
      localStorage.setItem("navigateMessage", "passwordChanged");
      navigate("/");
    } catch (error) {
      if (error.message === "Incorrect username or password.") {
        showToast("error", t("changePassword.errorMessage"));
      }
    }
  };

  return (
    <>
      <AppContent title={t("home.changePassword")}>
        <ChangePasswordForm onSubmit={onSubmit} />
      </AppContent>
    </>
  );
};

export default ChangePassword;
